export const handleMatchRegExp = /^[A-Za-z0-9][A-Za-z0-9-]+[A-Za-z0-9]$/;
/**
 * Used in some cases to allow authorization to perform administrative actions
 *
 * Not a great idea; don't protect incredibly important things with this, but until we get a more rigorous authorization
 * system, this will do in a pinch
 */
export const FluxOrganizationUid = "org_5403312a-7839-4723-8417-b22be0b5e6b3";
export const FluxInternalOrganizationUid = "org_a60d216e-c9fb-4965-97f9-f658097db12c";
//# sourceMappingURL=constants.js.map